import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license
 * Copyright 2018 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { dispose as _dispose } from '../globals';
import { variableGrads } from '../gradients';
import { scalar } from '../ops/ops';
import { Serializable } from '../serialization';
/** @doc {heading: 'Training', subheading: 'Classes', namespace: 'train'} */

export var Optimizer = /*#__PURE__*/function (_Serializable) {
  _inherits(Optimizer, _Serializable);

  var _super = _createSuper(Optimizer);

  function Optimizer() {
    _classCallCheck(this, Optimizer);

    return _super.apply(this, arguments);
  }

  _createClass(Optimizer, [{
    key: "minimize",

    /**
     * Executes `f()` and minimizes the scalar output of `f()` by computing
     * gradients of y with respect to the list of trainable variables provided by
     * `varList`. If no list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to minimize.
     * @param returnCost Whether to return the scalar cost value produced by
     * executing `f()`.
     * @param varList An optional list of variables to update. If specified, only
     * the trainable variables in varList will be updated by minimize. Defaults to
     * all trainable variables.
     */

    /** @doc {heading: 'Training', subheading: 'Optimizers'} */
    value: function minimize(f) {
      var returnCost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var varList = arguments.length > 2 ? arguments[2] : undefined;

      var _this$computeGradient = this.computeGradients(f, varList),
          value = _this$computeGradient.value,
          grads = _this$computeGradient.grads;

      if (varList != null) {
        var gradArray = varList.map(function (v) {
          return {
            name: v.name,
            tensor: grads[v.name]
          };
        });
        this.applyGradients(gradArray);
      } else {
        this.applyGradients(grads);
      } // Dispose gradients.


      _dispose(grads);

      if (returnCost) {
        return value;
      } else {
        value.dispose();
        return null;
      }
    }
    /**
     * The number of iterations that this optimizer instance has been invoked for.
     */

  }, {
    key: "incrementIterations",
    value: function incrementIterations() {
      this.iterations_ = this.iterations + 1;
    }
    /**
     * Executes f() and computes the gradient of the scalar output of f() with
     * respect to the list of trainable variables provided by `varList`. If no
     * list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to use for computing
     * gradients with respect to variables.
     * @param varList An optional list of variables to compute gradients with
     * respect to. If specified, only the trainable variables in varList will have
     * gradients computed with respect to. Defaults to all trainable variables.
     */

  }, {
    key: "computeGradients",
    value: function computeGradients(f, varList) {
      return variableGrads(f, varList);
    }
    /**
     * Dispose the variables (if any) owned by this optimizer instance.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      if (this.iterations_ != null) {
        _dispose(this.iterations_);
      }
    }
  }, {
    key: "saveIterations",
    value: function () {
      var _saveIterations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.iterations_ == null) {
                  this.iterations_ = 0;
                }

                return _context.abrupt("return", {
                  name: 'iter',
                  // TODO(cais): Use 'int64' type when available.
                  tensor: scalar(this.iterations_, 'int32')
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveIterations() {
        return _saveIterations.apply(this, arguments);
      }

      return saveIterations;
    }()
  }, {
    key: "getWeights",
    value: function () {
      var _getWeights = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                throw new Error('getWeights() is not implemented for this optimizer yet.');

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getWeights() {
        return _getWeights.apply(this, arguments);
      }

      return getWeights;
    }()
  }, {
    key: "setWeights",
    value: function () {
      var _setWeights = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(weightValues) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throw new Error("setWeights() is not implemented for this optimizer class " + "".concat(this.getClassName()));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setWeights(_x) {
        return _setWeights.apply(this, arguments);
      }

      return setWeights;
    }()
    /**
     * Extract the first element of the weight values and set it
     * as the iterations counter variable of this instance of optimizer.
     *
     * @param weightValues
     * @returns Weight values with the first element consumed and excluded.
     */

  }, {
    key: "extractIterations",
    value: function () {
      var _extractIterations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(weightValues) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return weightValues[0].tensor.data();

              case 2:
                this.iterations_ = _context4.sent[0];
                return _context4.abrupt("return", weightValues.slice(1));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function extractIterations(_x2) {
        return _extractIterations.apply(this, arguments);
      }

      return extractIterations;
    }()
  }, {
    key: "iterations",
    get: function get() {
      if (this.iterations_ == null) {
        this.iterations_ = 0;
      }

      return this.iterations_;
    }
  }]);

  return Optimizer;
}(Serializable);
Object.defineProperty(Optimizer, Symbol.hasInstance, {
  value: function value(instance) {
    return instance.minimize != null && instance.computeGradients != null && instance.applyGradients != null;
  }
});